import _ from "lodash";
import { getAppConfig } from "config/client.config";

export const FETCH_FEED = "FETCH_FEED";
export const FETCH_SINGLE_FEED = "FETCH_SINGLE_FEED";
export const MODIFY_FEED = "MODIFY_FEED";
export const TOGGLE_LIKE = "TOGGLE_LIKE";

const _fetchFeed = (status, data, err) => {
    return {
        type: FETCH_FEED,
        data,
        err,
        status
    };
};

const _modifyFeed = (status, data, err) => {
    return {
        type: MODIFY_FEED,
        data,
        err,
        status
    };
};

const fetchFeed = () => {
    return (dispatch, getState, Request) => {
        let feedPath = getAppConfig().endpoints.feedPath;
        dispatch(_fetchFeed("fetching", null, null));
        return Request.fetch(feedPath)
            .then(response => {
                return response.json().then(data => {
                    return dispatch(
                        _fetchFeed("success", { posts: data }, null)
                    );
                });
            })
            .catch(err => {
                dispatch(_fetchFeed("error", null, err));
                return Promise.reject(err);
            });
    };
};

const createPost = postHash => {
    return (dispatch, getState, Request) => {
        let createPostPath = getAppConfig().endpoints.createPostPath;
        let ownerId = getState().auth.user.id;
        let postBody = {};
        switch (postHash.type) {
            case "image":
            case "gallery":
                postBody = {
                    category: postHash.type,
                    description: postHash.text,
                    owner_id: ownerId,
                    content: _.map(postHash.images, image => {
                        return { image: image, _destroy: false };
                    }),
                    rules: postHash.rules,
                };
                break;
            case "text":
            case "link":
            case "video":
            default:
                postBody = {
                    category: postHash.type,
                    description: postHash.text,
                    content: postHash.content,
                    owner_id: ownerId,
                    rules: postHash.rules,
                };
        }
        return Request.fetch(createPostPath, {
            method: "POST",
            body: JSON.stringify(postBody)
        })
            .then(resp => {
                return resp.json();
            })
            .then(response => {
                let feedPath = getAppConfig().endpoints.feedPath;
                return Request.fetch(feedPath)
                    .then(response => {
                        return response.json().then(data => {
                            return dispatch(
                                _fetchFeed("success", { posts: data }, null)
                            );
                        });
                    })
                    .catch(err => {
                        dispatch(_fetchFeed("error", null, err));
                        return Promise.reject(err);
                    });
            })
            .catch(err => {
                console.log(err);
            });
    };
};

const deletePost = postId => {
    return (dispatch, getState, Request) => {
        let deletePostPath = getAppConfig().endpoints.deletePostPath.replace(
            ":id",
            postId
        );
        const feed = getState().feed;
        let index = _.findIndex(feed.posts, { _id: postId });
        return Request.fetch(deletePostPath, {
            method: "POST"
        })
            .then(response => {
                return response.json().then(data => {
                    feed.posts.splice(index, 1);
                    return Promise.resolve(
                        dispatch(_modifyFeed("success", feed, null))
                    );
                });
            })
            .catch(err => {
                return Promise.reject(err);
            });
    };
};

const addComment = (postId, comment) => {
    return (dispatch, getState, Request) => {
        let createPostCommentPath = getAppConfig().endpoints.createPostCommentPath.replace(
            ":id",
            postId
        );
        return Request.fetch(createPostCommentPath, {
            method: "POST",
            body: JSON.stringify({ comment: comment })
        })
            .then(response => {
                return response.json().then(data => {
                    let feedPath = getAppConfig().endpoints.feedPath;
                    return Request.fetch(feedPath)
                        .then(response => {
                            return response.json().then(data => {
                                return dispatch(
                                    _fetchFeed("success", { posts: data }, null)
                                );
                            });
                        })
                        .catch(err => {
                            dispatch(_fetchFeed("error", null, err));
                            return Promise.reject(err);
                        });
                });
            })
            .catch(err => {
                return Promise.reject(err);
            });
    };
};

const deleteComment = (postId, commentId) => {
    return (dispatch, getState, Request) => {
        let deletePostCommentPath = getAppConfig()
            .endpoints.deletePostCommentPath.replace(":id", postId)
            .replace(":comment_id", commentId);
        return Request.fetch(deletePostCommentPath, {
            method: "POST"
        })
            .then(response => {
                return response.json().then(data => {
                    let feedPath = getAppConfig().endpoints.feedPath;
                    return Request.fetch(feedPath)
                        .then(response => {
                            return response.json().then(data => {
                                return dispatch(
                                    _fetchFeed("success", { posts: data }, null)
                                );
                            });
                        })
                        .catch(err => {
                            dispatch(_fetchFeed("error", null, err));
                            return Promise.reject(err);
                        });
                });
            })
            .catch(err => {
                return Promise.reject(err);
            });
    };
};

class FeedAction {
    static createPost = createPost;
    static addComment = addComment;
    static deleteComment = deleteComment;
    static deletePost = deletePost;
    static fetchFeed = fetchFeed;
}

export default FeedAction;
